import axios from "axios";
import { storage } from "./storageService";

const BaseUrl = process.env.REACT_APP_API_URL;
const AuthBaseUrl = process.env.REACT_APP_API_URL_AUTH;
const HRBaseUrl = process.env.REACT_APP_API_URL_HR;

// Function to create axios instance
const axiosInstancePublic = axios.create({
  baseURL: BaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

const createAxiosInstance = (baseURL, contentType = "application/json") => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": contentType,
      Authorization: `Bearer ${storage.getToken()}`,
    },
  });

  // Sync request interceptor to always update token
  instance.interceptors.request.use(
    (config) => {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${storage.getToken()}`;
      return config;
    },
    null,
    { synchronous: true },
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;

      // If token expired or unauthorized
      if (error.response && status === 401) {
        // Only redirect if we are not already on "/"
        if (window.location.pathname !== "/") {
          storage.removeToken();
          storage.removeLoginId();
          window.location.href = "/";
        }
      }

      return Promise.reject(error);
    },
  );

  return instance;
};

// ---------------------------
// Base API
// ---------------------------
const axiosInstance = createAxiosInstance(BaseUrl);
const axiosInstanceForm = createAxiosInstance(BaseUrl, "multipart/form-data");

// ---------------------------
// Auth API
// ---------------------------
const axiosInstanceAuth = createAxiosInstance(AuthBaseUrl);
const axiosInstanceAuthForm = createAxiosInstance(AuthBaseUrl, "multipart/form-data");

// ---------------------------
// HR API
// ---------------------------
const axiosInstanceHR = createAxiosInstance(HRBaseUrl);
const axiosInstanceHRForm = createAxiosInstance(HRBaseUrl, "multipart/form-data");

export {
  axiosInstance,
  axiosInstanceForm,
  axiosInstanceAuth,
  axiosInstanceAuthForm,
  axiosInstanceHR,
  axiosInstanceHRForm,
  axiosInstancePublic,
};
